import { render, staticRenderFns } from "./CompanyPOSettlement.vue?vue&type=template&id=3385985a&"
import script from "./CompanyPOSettlement.vue?vue&type=script&lang=js&"
export * from "./CompanyPOSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports